enum ResendEmailReceiver {
    Customer = 'Customer',
    Booker = 'Booker',
    Custom = 'Custom',
    NotSelected = 'NotSelected',
}

export default ResendEmailReceiver;
